import { Box, Button, Stack, Typography } from "@mui/material";

import { signOut } from "aws-amplify/auth";

import LanguageIcon from "@mui/icons-material/Language";
import { useDispatch } from "react-redux";
import { logout, setSignInStep } from "@store/slices/authSlice";

interface FormularioCuentaBloqueadaProps {}

export const FormularioCuentaBloqueada = (props: FormularioCuentaBloqueadaProps) => {
    const dispatch = useDispatch();

    return (
        <Stack my={2} mx={4} direction={"column"} justifyContent={"flex-start"} alignItems={"center"}>
            <Typography variant="h2" fontWeight={700} color="#002652">
                {"Lo sentimos"}
            </Typography>
            <Box display={"flex"} alignItems={"center"} flexDirection={"column"}>
                <Typography mt={3} textAlign={"center"} variant="body1" color="#002652">
                    Tu cuenta ha sido bloqueada ya que has llegado al máximo número de intentos para ingresar el código
                    de autenticación
                </Typography>
                <Typography color="main2" variant="body1" fontWeight={700} my={4}>
                    {localStorage.getItem("email") ?? ""}
                </Typography>
                <Typography mt={3} textAlign={"center"} variant="body1" color="main3">
                    Para desbloquear tu cuenta contacta a soporte:
                </Typography>
                <Box display={"flex"} flexDirection={"row"} my={3}>
                    <LanguageIcon color="main3" />
                    <Typography textAlign={"center"} variant="body1" color="main3">
                        contacto@lendia.mx
                    </Typography>
                </Box>
            </Box>

            <Button
                variant="contained"
                onClick={async () => {
                    await signOut();
                    dispatch(logout());
                    dispatch(setSignInStep(""));
                }}
            >
                Regresar
            </Button>
        </Stack>
    );
};
